
import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  Slider,
  IconButton,
} from "@mui/material";
import ReplayIcon from "@mui/icons-material/Replay";
import DirectionsWalkIcon from "@mui/icons-material/DirectionsWalk";
import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import BatteryFullIcon from "@mui/icons-material/BatteryFull";



import {
  MapContainer,
  TileLayer,
  Polyline,
  Marker,
  Popup,
  useMap,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import myMarkerIcon from "./image/image2.png";

import SignalChartBox from "../src/category/SignalChartBox"; // Adjust the path if needed
import BatteryChartBox from "../src/category/BatteryChartBox"
import WalkChartBox from '../src/category/WalkChartBox'
//import ShowChartBox from "@mui/icons-material/ShowChart";
import HistoryBox from '../src/category/HistoryBox';

//import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
//import axios from './AxiosInstance';
import { fetchWithAuth } from './fetchWithAuth';
// Custom Marker Icon
const customIcon = L.icon({
  iconUrl: myMarkerIcon,
  iconSize: [48, 48],
  iconAnchor: [24, 48],
  popupAnchor: [0, -48],
});

// Calculate angle between two GPS points
function getAngle(from, to) {
  const dx = to.lng - from.lng;
  const dy = to.lat - from.lat;
  return (Math.atan2(dy, dx) * 180) / Math.PI;
}



// Main Component
const HistoryPage = () => {
  const [devices, setDevices] = useState([]);
  const [deviceId, setDeviceId] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [trackData, setTrackData] = useState([]);
  const [playing, setPlaying] = useState(false);
  const [speed, setSpeed] = useState(1);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedIcons, setSelectedIcons] = useState({
    walk: true,
    signal: false,
    chart: false,
    battery: false,
  });
  const [showSignalChart, setShowSignalChart] = useState(false);
  const [showBatteryChart, setShowBatteryChart] = useState(false);
  const [showWalkChart, setShowWalkChart] = useState(false);
  // const [showChart, setShowChart] = useState(false);//update
  const [showHistory, setShowHistory] = useState(false);
  const navigate = useNavigate();
  const intervalRef = useRef(null);
  const mapRef = useRef(null);
  //const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const currentUser = sessionStorage.getItem("currentUser");
    const token = sessionStorage.getItem(`token_${currentUser}`);
  
    if (!token) {
      navigate("/");
    } else {
      //setIsAuthenticated(true);
  
      fetchWithAuth(`/api/devices`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        // .then((res) => {
        //   if (!res.ok) throw new Error("Failed to fetch devices");
        //   return res.json();
        // })
        .then((data) => setDevices(data))
        .catch((err) => console.error("Error fetching devices:", err));
    }
  }, [navigate]);
  

  const handleGetHistory = async () => {
    if (!deviceId || !startTime || !endTime) {
      return alert("Please fill all fields!");
    }

    try {
      const response = await fetchWithAuth(
        `/api/history?devicename=${deviceId}&start=${startTime}&end=${endTime}`
      );
      const data = await response;
      const flattenedTrack = data.track.flat();
      setTrackData(flattenedTrack);
      console.log(flattenedTrack);
      setCurrentIndex(0);
      setPlaying(false);

      if (mapRef.current && flattenedTrack.length > 0) {
        mapRef.current.flyTo([flattenedTrack[0].lat, flattenedTrack[0].lng], 16);
      }
    } catch (error) {
      console.error("Error fetching history:", error);
    }
  };

  const handlePlayPause = () => {
    if (playing) {
      clearInterval(intervalRef.current);
      setPlaying(false);
    } else {
      if (trackData.length === 0) return;
      setPlaying(true);
      intervalRef.current = setInterval(() => {
        setCurrentIndex((prev) => {
          if (prev < trackData.length - 1) {
            return prev + 1;
          } else {
            clearInterval(intervalRef.current);
            setPlaying(false);
            return prev;
          }
        });
      }, 1000 / speed);
    }
  };

  const handleReplay = () => {
    clearInterval(intervalRef.current);
    setCurrentIndex(0);
    setPlaying(false);
  };

  const handleSpeedChange = (_, newValue) => {
    setSpeed(newValue);
    if (playing) {
      clearInterval(intervalRef.current);
      intervalRef.current = setInterval(() => {
        setCurrentIndex((prev) => {
          if (prev < trackData.length - 1) {
            return prev + 1;
          } else {
            clearInterval(intervalRef.current);
            setPlaying(false);
            return prev;
          }
        });
      }, 1000 / newValue);
    }
  };

  const toggleIcon = (iconName) => {
    setSelectedIcons((prev) => {
      const newState = {
        ...prev,
        [iconName]: !prev[iconName],
      };
  
      // Control chart visibility based on iconName and new state
      if (iconName === 'signal') {
        setShowSignalChart(newState[iconName]);
      } else if (iconName === 'battery') {
        setShowBatteryChart(newState[iconName]);
      }else if (iconName === 'chart') {
        setShowHistory(newState[iconName]);
      }
      return newState;
    });
  };
  

  const handleSignalClick = () => {
    setShowSignalChart((prev) => !prev);
  };

  const MapSetRef = () => {
    const map = useMap();
    useEffect(() => {
      mapRef.current = map;
    }, [map]);
    return null;
  };

  // const signalData = trackData.map((point) => ({
  //   time: point.dev_ts,
  //   signal: Math.abs(point.rssi),
  // }));
  const signalData = trackData
  .filter((_, index) => index % 5 === 0) // Keep every 5th point (0, 5, 10, ...)
  .map((point) => ({
    time: point.dev_ts,
    signal: Math.abs(point.rssi),
  }));
//////////////////////
const batteryData = trackData.map((point) => ({
  time: point.dev_ts,
  //battery: point.battery, // Ensure `battery` is a valid field
  battery: point.battery != null && point.battery !== '' ? point.battery : 80
}));

  
///////////////////////
 const handleBatteryClick = () => {
  setShowBatteryChart(prev => !prev);
};

///
const beatData = [
  {
    startBeat: 16.2,
    endBeat: 19.3,
    startTime: '05:00',
    endTime: '15:00',
  },
  // You can add more entries if needed
];

const handleWalkClick = () => {
  setShowWalkChart(prev => !prev);
};


const handleSignalClick2 = () => {
  setShowHistory
  (prev => ! prev);
};

const dummyHistory = trackData.map(point => ({
  datetime: new Date(point.dev_ts).toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }),
  status: 'Live',
  latitude: point.lat?.toString() || '0',
  longitude: point.lng?.toString() || '0',
  speed: 0,
  location: '', // You can fill in if you have location names
  rdpskm: '',   // Optional, if data exists
  battery: point.battery_level != null ? `${point.battery_level}%` : '80%',
  network: point.rssi != null ? `${Math.max(0, 100 + point.rssi)}%` : '100%',
}));


/////////////////////
  return (
    <Box display="flex" height="100vh">
      {/* Sidebar */}
      <Paper elevation={3} sx={{ width: 300, p: 2, overflowY: "auto" }}>
        <Typography variant="h6" gutterBottom>
          Device History
        </Typography>

        <FormControl fullWidth sx={{ mb: 3 }}>
          <InputLabel>Select Device</InputLabel>
          <Select
            value={deviceId}
            label="Select Device"
            onChange={(e) => setDeviceId(e.target.value)}
          >
            {devices.map((device) => (
              <MenuItem key={device.id} value={device.name}>
                {device.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          label="Start Time"
          type="datetime-local"
          fullWidth
          value={startTime}
          onChange={(e) => setStartTime(e.target.value)}
          sx={{ mb: 2 }}
          InputLabelProps={{ shrink: true }}
        />

        <TextField
          label="End Time"
          type="datetime-local"
          fullWidth
          value={endTime}
          onChange={(e) => setEndTime(e.target.value)}
          sx={{ mb: 2 }}
          InputLabelProps={{ shrink: true }}
        />

        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleGetHistory}
          sx={{ mb: 2 }}
        >
          Get History
        </Button>

        {trackData.length > 0 && (
          <>
            <Button
              variant="contained"
              color={playing ? "secondary" : "success"}
              fullWidth
              onClick={handlePlayPause}
              sx={{ mb: 2 }}
            >
              {playing ? "Pause" : "Play"}
            </Button>

            <Button
              variant="contained"
              color="warning"
              fullWidth
              startIcon={<ReplayIcon />}
              onClick={handleReplay}
              sx={{ mb: 2 }}
            >
              Replay
            </Button>

            <Typography gutterBottom>Speed: {speed}x</Typography>
            <Slider
              value={speed}
              onChange={handleSpeedChange}
              min={1}
              max={5}
              step={1}
              marks
              valueLabelDisplay="auto"
              sx={{ mb: 2 }}
            />

            <Box display="flex" justifyContent="space-around" mt={2}>
              <IconButton
                onClick={() => toggleIcon("walk")}
                color={selectedIcons.walk ? "primary" : "default"}
              >
                <DirectionsWalkIcon />
              </IconButton>
              <IconButton
                onClick={() => toggleIcon("signal")}
                color={selectedIcons.signal ? "primary" : "default"}
              >
                <SignalCellularAltIcon />
              </IconButton>
              <IconButton
                onClick={() => toggleIcon("chart")}
               // onClick={() => Hbutten}
                color={selectedIcons.chart ? "primary" : "default"}
              >
                <ShowChartIcon />
              </IconButton>
              <IconButton
                onClick={() => toggleIcon("battery")}
                color={selectedIcons.battery ? "primary" : "default"}
              >
                <BatteryFullIcon />
              </IconButton>
            </Box>
          </>
        )}
      </Paper>

      {/* Map Area */}
      <Box flex={1}>
        <div style={{ position: "relative", height: "100%" }}>
          <MapContainer
            center={[22.9734, 78.6569]}
            zoom={5}
            style={{ height: "100%", width: "100%" }}
          >
            <MapSetRef />
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

            {selectedIcons.walk && trackData.length > 0 && (
              <Polyline
                positions={trackData.map((p) => [p.lat, p.lng])}
                color="blue"
                weight={4}
                opacity={0.7}
              />
            )}

            {selectedIcons.walk &&
              trackData.map((point, idx) => {
                if (idx === 0) return null;
                const angle = getAngle(trackData[idx - 1], point);
                const icon = L.divIcon({
                  className: "arrow-icon",
                  html: `
                    <div style="
                      width: 20px;
                      height: 20px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      transform: rotate(${angle}deg);
                      font-size: 20px;
                      color: blue;
                    ">
                      ➤
                    </div>
                  `,
                  iconSize: [25, 25],
                  iconAnchor: [10, 10], // center of the icon
                });
                
                return (
                  <Marker key={idx} position={[point.lat, point.lng]} icon={icon} />
                );
              })}

            {trackData.length > 0 && (
              <Marker
                position={[
                  trackData[currentIndex].lat,
                  trackData[currentIndex].lng,
                ]}
                icon={customIcon}
              >
                <Popup>
                  Speed: {trackData[currentIndex].speed} km/h <br />
                  Time:{" "}
                  {new Date(trackData[currentIndex].dev_ts).toLocaleString()} <br />
                  RSSI: {trackData[currentIndex].rssi} dBm
                </Popup>
              </Marker>
            )}

            {selectedIcons.signal && (
              <Marker
                position={[trackData[currentIndex].lat, trackData[currentIndex].lng]}
                icon={L.divIcon({ html: "<div style='font-size:24px;'>📶</div>" })}
              />
            )}
            {selectedIcons.chart && (
              <Marker
                position={[trackData[currentIndex].lat, trackData[currentIndex].lng]}
                icon={L.divIcon({ html: "<div style='font-size:24px;'>📈</div>" })}
              />
            )}
            {selectedIcons.battery && (
              <Marker
                position={[trackData[currentIndex].lat, trackData[currentIndex].lng]}
                icon={L.divIcon({ html: "<div style='font-size:24px;'>🔋</div>" })}
              />
            )}
          </MapContainer>




{/* Walk Icon */}
<div style={{ position: "absolute", top: 10, right: 140, zIndex: 999 }}>
  <button onClick={handleWalkClick} style={{ background: "none", border: "none", padding: 0, cursor: 'pointer' }}>
    <Box sx={{
      backgroundColor: 'black',
      borderRadius: '40%',
      width: 46,
      height: 46,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <DirectionsWalkIcon sx={{ color: showWalkChart ? 'lime' : 'yellow', fontSize: 26 }} />
    </Box>
  </button>
</div>

{showWalkChart && (
  <WalkChartBox
    deviceId="359751090207643"
    beatData={beatData}
    onClose={() => setShowWalkChart(false)}
  />
)}

{/* Signal Icon */}
<div style={{ position: "absolute", top: 10, right: 20, zIndex: 999 }}>
  <button onClick={handleSignalClick} style={{ background: "none", border: "none", padding: 0, cursor: 'pointer' }}>
    <Box sx={{
      backgroundColor: 'black',
      borderRadius: '40%',
      width: 46,
      height: 46,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <SignalCellularAltIcon sx={{ color: showSignalChart ? 'lime' : 'yellow', fontSize: 26 }} />
    </Box>
  </button>
</div>

{showSignalChart && <SignalChartBox data={signalData}  onClose={() => setShowSignalChart(false)} />}

{/* Battery Icon */}
<div style={{ position: 'absolute', top: 10, right: 80, zIndex: 999 }}>
  <button onClick={handleBatteryClick} style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}>
    <Box sx={{
      backgroundColor: 'black',
      borderRadius: '40%',
      width: 46,
      height: 46,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <BatteryFullIcon sx={{ color: showBatteryChart ? 'lime' : 'yellow', fontSize: 26 }} />
    </Box>
  </button>
</div>

{showBatteryChart && (
  <BatteryChartBox
    data={batteryData}
    onClose={() => setShowBatteryChart(false)}
  />
)}


<div style={{ position: "absolute", top: 10, right: 200, zIndex: 999 }}>
  <button
    onClick={handleSignalClick2}
    style={{ background: "none", border: "none", padding: 0, cursor: 'pointer' }}
  >
    <Box
      sx={{
        backgroundColor: 'black',
        borderRadius: '40%',
        width: 46,
        height: 46,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {/* ✅ Use the state value to change icon color */}
      <ShowChartIcon sx={{ color: showHistory ? 'lime' : 'yellow', fontSize: 26 }} />
    </Box>
  </button>
</div>

{/* ✅ Show your custom chart component when active */}
{/* {showChart && <ShowChartBox data={ dummyHistory} onClose={() => setShowBatteryChart(false)} />} */}
{showHistory && (
        <HistoryBox
          data={dummyHistory}
          onClose={() => setShowHistory(false)}
        />
      )}

    </div>
      </Box>
    </Box>
  );
};

export default HistoryPage;
